import { put, call, takeLatest, select } from 'redux-saga/effects';
import { AxiosError } from 'axios';
import i18next from 'i18next';

import { unlockAdvocate as unlockAdvocateCall } from 'services/advocate';
import { AsyncAction } from 'types/Action';
import {
  UnlockAdvocateCallPayload,
  UnlockAdvocateCalllMeta,
} from 'types/store/UnlockAdvocateCall';
import { Store } from 'types/store/Store';
import unlockAdvocateCallActions from 'store/actions/unlockAdvocate';
import { translations } from 'locales/i18n';
import { ErrorResponse } from 'utils/handleAxiosError';

import { openToast } from '../actions';

function* unlockAdvocateRequest(
  action: AsyncAction<UnlockAdvocateCalllMeta, UnlockAdvocateCallPayload>,
) {
  const state: Store = yield select();
  if (state.auth.token) {
    try {
      const { data } = yield call(
        unlockAdvocateCall,
        state.auth.token,
        action.meta,
      );
      yield put(
        openToast(
          data.message,
          'success',
          i18next.t(translations.UnlockUserSuccess),
        ),
      );
      action.meta.callback?.();
    } catch (e: unknown) {
      const errorMessage = e as AxiosError<ErrorResponse>;
      yield put(
        openToast(
          errorMessage?.response?.data.message ??
            'An unexpected error occurred',
          'error',
        ),
      );
    }
  }
}

function* advocateBulkCallWatcher(): any {
  yield takeLatest(unlockAdvocateCallActions.REQUEST, unlockAdvocateRequest);
}

export default advocateBulkCallWatcher;
